import { leagueFetch } from '@leagueplatform/league-fetch';

const USER_API = '/v1/users';

export async function deleteLeagueUser(userId: string): Promise<boolean> {
  const response = await leagueFetch(`${USER_API}/${userId}`, {
    method: 'DELETE',
  });
  if (!response?.ok) {
    throw new Error(
      `Error Response Code ${response?.status}: ${await response.text()}`,
    );
  }
  return response.ok;
}
